import React from "react";

import logo from '../../assets/images/dt_logo_black.png';
import './header.css';


// import { useMsal } from "@azure/msal-react";
// import { useIsAuthenticated } from "@azure/msal-react";
// import { loginRequest } from "../../authConfig";
// import {InteractionStatus} from "@azure/msal-browser";



const Header = () => {
    // const {instance,inProgress,accounts} = useMsal();
    // const isAuthenticated = useIsAuthenticated();
  
    // const handleLogin = () => {
    //         if(inProgress === InteractionStatus.None && !isAuthenticated) { 
    //         instance.loginRedirect(loginRequest).catch(e => {console.log(e);});
    //     }
    // }

    return <div className="secnav__header">
       <div className="secnav__header__logo">
       <img src={logo} alt='Daimler Truck Logo'/>
       </div>
       {/* <div className="secnav__header__button">
       <button type="button" disabled={true}>Start SecNav</button>
       </div> */}
       <hr />
    </div>
};

export default Header;